import React, { useEffect } from "react";
import SubpageTitle from "../components/subpageTitle";
import Footer from "../components/footer"
import { collection, getDocs } from "firebase/firestore";
import db from "../firebaseConfig";
import { AdvancedMarker, APIProvider, InfoWindow, Map, Pin, useMap } from '@vis.gl/react-google-maps';

const NEARBY_RADIUS_MILES = 100;

function haversineDistance(lat1, lng1, lat2, lng2) {
    const toRad = (x) => x * Math.PI / 180;
    const R = 3958.8;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}


function MapBoundsController({ stores, userPos }) {
    const map = useMap();

    useEffect(() => {
        if (!map || stores.length === 0 || userPos === undefined) return;

        const bounds = new window.google.maps.LatLngBounds();

        if (userPos) {
            const nearby = stores.filter(s =>
                haversineDistance(userPos.lat, userPos.lng, s.lat, s.lon) <= NEARBY_RADIUS_MILES
            );
            const toShow = nearby.length > 0 ? nearby : stores;
            toShow.forEach(s => bounds.extend({ lat: s.lat, lng: s.lon }));
            if (nearby.length > 0) bounds.extend(userPos);
        } else {
            stores.forEach(s => bounds.extend({ lat: s.lat, lng: s.lon }));
        }

        map.fitBounds(bounds, 40);
    }, [map, stores, userPos]);

    return null;
}

function MapPanController({ selected }) {
    const map = useMap();
    useEffect(() => {
        if (!map || !selected) return;
        map.panTo({ lat: selected.lat, lng: selected.lon });
    }, [map, selected]);
    return null;
}

const StoreMarkers = ({ locations, selected, setSelected }) => {
    return (
        <>
            {locations.map((store) => (
                <AdvancedMarker
                    key={store.storeNum}
                    position={{ lat: store.lat, lng: store.lon }}
                    onClick={() => setSelected(store)}>
                    <Pin background={'#e80f00'} glyphColor={'#6e0a03'} borderColor={'#8c7a79'} />
                </AdvancedMarker>
            ))}
            {selected && (
                <InfoWindow
                    position={{ lat: selected.lat, lng: selected.lon }}
                    onCloseClick={() => setSelected(null)}
                    headerDisabled={true}>
                    <div style={{ position: 'relative', paddingRight: '20px' }}>
                        <button
                            onClick={() => setSelected(null)}
                            style={{ position: 'absolute', top: 0, right: 0, background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', lineHeight: 1, color: '#666' }}
                            aria-label="Close">
                            ✕
                        </button>
                        <p className="font-semibold">{selected.storeName}</p>
                        <p>{selected.streetAddress}<br />{selected.city}, {selected.state} {selected.zipCode}</p>
                        <a
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${selected.streetAddress}, ${selected.city}, ${selected.state} ${selected.zipCode}`)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#1a73e8'}}
                            className="pt-2">
                            Get Directions
                        </a>
                    </div>
                </InfoWindow>
            )}
        </>
    )
}

function Locations() {
    const [selected, setSelected] = React.useState(null)
    const [storeData, setStoreData] = React.useState([])
    // undefined = pending, null = failed/unavailable, {lat, lng} = success
    const [userPos, setUserPos] = React.useState(undefined)

    useEffect(() => {
      const getStoreNames = async () => {
        const querySnapshot = await getDocs(collection(db, "stores"))
        const storeDocs = []
        querySnapshot.forEach((doc) => {
            storeDocs.push(doc.data())
        })
        return storeDocs
      }

      getStoreNames().then((docs) => {
        setStoreData(docs)
      })

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setUserPos({ lat: position.coords.latitude, lng: position.coords.longitude })
            },
            () => {
                setUserPos(null)
            }
        )
      } else {
        setUserPos(null)
      }
    }, [])

    function focusOnStore(store) {
        setSelected(store)
    }

    return (
        <div>
            <SubpageTitle title="Our Locations"/>
            <div>
                <div className="flex flex-col-reverse md:flex-row h-200 w-9/10 md:w-2/3 mx-auto my-30">
                    <div className="md:h-full h-1/2 md:w-1/4 overflow-y-auto border border-gray-300">
                        <ul id="locations-list">
                            {storeData.sort((a, b) => a.storeNum - b.storeNum).map((store, index) => {
                                return (
                                    <li className="border-y border-gray-300 p-3" key={store.storeNum} onClick={() => focusOnStore(store)}>
                                        <p className="text-xl font-semibold">{store.storeName}</p>
                                        <p>{store.streetAddress}<br/>{store.city}, {store.state} {store.zipCode}</p>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                    <div className="flex-1 h-full">
                        <APIProvider apiKey="AIzaSyC5vqpWx2fvX25vIwM6KwwaitP949iE-6Q" onLoad={() => console.log("Maps API has loaded")}>
                            <Map defaultZoom={8}
                            defaultCenter={{ lat: 41.5, lng: -74.1 }}
                            mapId={"63f2b3e07a64b09532ef4378 "}
                            onClick={() => setSelected(null)}>
                                <StoreMarkers locations={storeData} selected={selected} setSelected={setSelected} />
                                <MapBoundsController stores={storeData} userPos={userPos} />
                                <MapPanController selected={selected} />
                            </Map>
                        </APIProvider>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}




export default Locations
